  <div mat-dialog-title>
    <app-header-detail
      [disableLoadDefaultButtons]="data?.headerDetail?.disableLoadDefaultButtons || false"
      [dialogId]="dialogId">
   </app-header-detail>
  </div>
  
   <mat-dialog-content>
      <ng-template #container></ng-template>
  </mat-dialog-content >


  
  
  
  

